import React, { FC } from 'react';

import { appRoutes } from '@app/config/app_routes';
import queryString from 'query-string';
import { toSnakeCase } from '@common/config/utils';
import AppLink from '@app/components/routes/app_link';
import classes from './classes.module.scss';

type Filter = {
  filterTitle: string,
  iconUrl: string,
  id: string,
  params: Record<string, string | boolean | number>,
  title: string,
  slug?: string
};

type Props = {
  content: {
    filters: Filter[]
  }
};

export const FiltersSection: FC<Props> = ({ content: { filters } }) => {
  if (filters.length === 0) return null;
  return (
    <div className={ classes.container }>
      {filters.map((filter, index) => {
        const searchParams = toSnakeCase(
          Object.keys(filter.params)
            .filter(x => x !== 'hps')
            .reduce((obj: { [key: string]: string | number | boolean }, key: string) => {
              obj[key] = filter.params[key];
              return obj;
            }, {})
        );
        return (
          <AppLink
            to={ {
              pathname: filter.slug || appRoutes.psychics,
              state: {
                needRefresh: true,
                params: filter.params
              },
              search: filter.slug ? undefined : `?${ queryString.stringify(searchParams) }`
            } }
            key={ index }
            className={ classes.btnLink }
          >
            <button key={ filter.id } className={ classes.btn } type="button">
              <img className={ classes.icon } src={ filter.iconUrl } alt="icon" />
              <span className={ classes.name }>{filter.title}</span>
            </button>
          </AppLink>
        );
      })}
    </div>
  );
};
